/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PamPlayerStatus } from './PamPlayerStatus';
import {
    PamPlayerStatusFromJSON,
    PamPlayerStatusFromJSONTyped,
    PamPlayerStatusToJSON,
} from './PamPlayerStatus';
import type { PamDuplicateCandidateAddress } from './PamDuplicateCandidateAddress';
import {
    PamDuplicateCandidateAddressFromJSON,
    PamDuplicateCandidateAddressFromJSONTyped,
    PamDuplicateCandidateAddressToJSON,
} from './PamDuplicateCandidateAddress';
import type { PamPlayerVerificationStatus } from './PamPlayerVerificationStatus';
import {
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusFromJSONTyped,
    PamPlayerVerificationStatusToJSON,
} from './PamPlayerVerificationStatus';

/**
 * A potential duplicate account sharing the subject's DOB+SSN4, for back-office diagnosis.
 * Resolved live from current dedup matches. `ssn4` is stripped by back-office-service unless
 * the caller holds read:player-ssn.
 * @export
 * @interface PamDuplicateCandidate
 */
export interface PamDuplicateCandidate {
    /**
     * 
     * @type {PamPlayerVerificationStatus}
     * @memberof PamDuplicateCandidate
     */
    verificationStatus: PamPlayerVerificationStatus;
    /**
     * 
     * @type {PamPlayerStatus}
     * @memberof PamDuplicateCandidate
     */
    accountStatus: PamPlayerStatus;
    /**
     * 
     * @type {PamDuplicateCandidateAddress}
     * @memberof PamDuplicateCandidate
     */
    address: PamDuplicateCandidateAddress | null;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidate
     */
    ssn4?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidate
     */
    dob?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidate
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidate
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidate
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidate
     */
    lookupId: string;
}



/**
 * Check if a given object implements the PamDuplicateCandidate interface.
 */
export function instanceOfPamDuplicateCandidate(value: object): value is PamDuplicateCandidate {
    if (!('verificationStatus' in value) || value['verificationStatus'] === undefined) return false;
    if (!('accountStatus' in value) || value['accountStatus'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('lookupId' in value) || value['lookupId'] === undefined) return false;
    return true;
}

export function PamDuplicateCandidateFromJSON(json: any): PamDuplicateCandidate {
    return PamDuplicateCandidateFromJSONTyped(json, false);
}

export function PamDuplicateCandidateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDuplicateCandidate {
    if (json == null) {
        return json;
    }
    return {
        
        'verificationStatus': PamPlayerVerificationStatusFromJSON(json['verificationStatus']),
        'accountStatus': PamPlayerStatusFromJSON(json['accountStatus']),
        'address': PamDuplicateCandidateAddressFromJSON(json['address']),
        'ssn4': json['ssn4'] == null ? undefined : json['ssn4'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'displayName': json['displayName'],
        'lookupId': json['lookupId'],
    };
}

export function PamDuplicateCandidateToJSON(value?: PamDuplicateCandidate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'verificationStatus': PamPlayerVerificationStatusToJSON(value['verificationStatus']),
        'accountStatus': PamPlayerStatusToJSON(value['accountStatus']),
        'address': PamDuplicateCandidateAddressToJSON(value['address']),
        'ssn4': value['ssn4'],
        'dob': value['dob'],
        'phone': value['phone'],
        'email': value['email'],
        'displayName': value['displayName'],
        'lookupId': value['lookupId'],
    };
}

